export default class DDValidationReview {
  //fetchify validation
  constructor($module) {
    let checkboxInformation = document.querySelector(
      'input[name="InformationCheckbox"]'
    );

    let buttonInformation = document.getElementById("nextPageButtonId");

    checkboxInformation.addEventListener("change", updateButton);

    function updateButton() {
      if (checkboxInformation.checked) {
        buttonInformation.disabled = false;
      } else {
        buttonInformation.setAttribute("disabled", "disabled");
      }
    }
  }
}
